"use strict";

exports.__esModule = true;
exports.ElementEditorVerticalToolbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDnd = require("react-dnd");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _WidgetPalette = require("../../WidgetPalette");
var _Theme = require("../../../Theme");
var _Core = require("../../../Core");
var _dec, _class, _ElementEditorVerticalToolbar;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var wobble = (0, _styledComponents.keyframes)(["16.65%{transform:translateY(6px);}33.3%{transform:translateY(-6px);}49.95%{transform:translateY(4px);}66.6%{transform:translateY(-2px);}83.25%{transform:translateY(1px);}100%{transform:translateY(0);}"]);
var Container = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorVerticalToolbar__Container",
  componentId: "sc-qbm8cm-0"
})(["grid-area:palette;overflow-y:auto;background:", ";z-index:20;"], (0, _Theme.val)("WidgetPaletteBackground"));
var DustbinContainer = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorVerticalToolbar__DustbinContainer",
  componentId: "sc-qbm8cm-1"
})(["height:100%;background:rgba(0,0,0,0.1);display:flex;align-items:center;justify-content:center;.", "{animation-name:", ";animation-duration:1s;animation-timing-function:ease-in-out;animation-iteration-count:1;}"], _core.Classes.ICON, wobble);
var StyledInputGroup = (0, _styledComponents["default"])(_core.InputGroup).withConfig({
  displayName: "ElementEditorVerticalToolbar__StyledInputGroup",
  componentId: "sc-qbm8cm-2"
})(["margin:0.5rem;border-radius:0px;font-size:10px;& input{border-radius:0px;&:focus{outline:none;box-shadow:none;}}"]);
var elementTarget = {
  drop: function drop(props, monitor) {
    var elementEditor = props.elementEditor;
    var _monitor$getItem = monitor.getItem(),
      path = _monitor$getItem.path;
    elementEditor.removeElementAt(path);
  }
};

/**
 * Shows either a vertical toolbar or a dustbin that boxes can be dropped onto,
 * depending on whether a box is currently being dragged or not.
 */
var ElementEditorVerticalToolbar = exports.ElementEditorVerticalToolbar = (_dec = (0, _reactDnd.DropTarget)("element", elementTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}), _dec(_class = (_ElementEditorVerticalToolbar = /*#__PURE__*/function (_Component) {
  function ElementEditorVerticalToolbar() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementEditorVerticalToolbar, _Component);
  var _proto = ElementEditorVerticalToolbar.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      elementEditor = _this$props.elementEditor,
      connectDropTarget = _this$props.connectDropTarget,
      searchQuery = _this$props.searchQuery,
      onSearch = _this$props.onSearch;
    var translate = this.context.translate;
    if (elementEditor.draggingPath) {
      return /*#__PURE__*/_react["default"].createElement(Container, {
        "data-testid": "ElementEditorVerticalToolbar"
      }, /*#__PURE__*/_react["default"].createElement(DustbinContainer, {
        ref: connectDropTarget
      }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
        size: 48,
        icon: _icons.IconNames.TRASH
      })));
    }
    var filteredWidgets = elementEditor.widgets.filter(function (widget) {
      return widget.showInPalette;
    }).filter(function (widget) {
      var translatedLabel = translate(widget.label.props.id, widget.label.props.defaultMessage);
      return translatedLabel.toLowerCase().includes(searchQuery.toLowerCase());
    });
    return /*#__PURE__*/_react["default"].createElement(Container, {
      "data-testid": "ElementEditorVerticalToolbar"
    }, /*#__PURE__*/_react["default"].createElement(StyledInputGroup, {
      value: searchQuery,
      onChange: function onChange(e) {
        return onSearch(e.target.value);
      },
      placeholder: translate("ElementEditorVerticalToolbar.search", "Search"),
      leftIcon: _icons.IconNames.SEARCH
    }), /*#__PURE__*/_react["default"].createElement(_WidgetPalette.WidgetPalette, {
      elementEditor: elementEditor,
      widgets: filteredWidgets
    }));
  };
  return ElementEditorVerticalToolbar;
}(_react.Component), _ElementEditorVerticalToolbar.contextType = _Core.TranslatorContext, _ElementEditorVerticalToolbar)) || _class);